import React from 'react';
import { useTranslation } from 'react-i18next';
import { Download } from 'lucide-react';
import { useAppStore } from '../../store/useAppStore';
import { exportPNG, exportSVG, exportPDF } from '../../utils/export';
import './ExportBar.css';

export const ExportBar: React.FC = () => {
  const { t } = useTranslation('export');
  const content = useAppStore(state => state.content);
  const config = useAppStore(state => state.config);
  const logoFile = useAppStore(state => state.logoFile);

  const disabled = !content;

  const handleExport = async (format: 'png' | 'svg' | 'pdf') => {
    if (disabled) return;

    try {
      const filename = `MamaQR-${new Date().getTime()}.${format}`;
      if (format === 'png') {
        await exportPNG(content, config, 1024, logoFile, filename);
      } else if (format === 'svg') {
        await exportSVG(content, config, logoFile, filename);
      } else {
        await exportPDF(content, config, logoFile, filename);
      }
    } catch {
      alert(t('export.error', 'An error occurred during export.'));
    }
  };

  return (
    <div className="export-bar">
      <div className="export-group-surfaced">
        <button 
          className="export-btn primary" 
          disabled={disabled}
          onClick={() => { void handleExport('png'); }}
          aria-label={t('export.png', 'Download PNG')}
        >
          <Download size={18} /> PNG
        </button>
        <button 
          className="export-btn secondary" 
          disabled={disabled}
          onClick={() => { void handleExport('svg'); }}
          aria-label={t('export.svg', 'Download SVG')}
        >
          <Download size={18} /> SVG
        </button>
        <button 
          className="export-btn secondary" 
          disabled={disabled}
          onClick={() => { void handleExport('pdf'); }}
          aria-label={t('export.pdf', 'Download PDF')}
        >
          <Download size={18} /> PDF
        </button>
      </div>
    </div>
  );
};
